import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface Hires {
  first_name: string;
  last_name: string;
  email: string;
  mobile?: string;
  file: FileList;
  description?: string;
}

export class HiresRepository extends BaseRepository<Hires> {
  collection = "hires";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  create(data: Hires): Promise<ApiResponse<Hires>> {
    const formData = new FormData();
    formData.append("first_name", data.first_name);
    formData.append("last_name", data.last_name);
    formData.append("file", data.file[0]);
    formData.append("email", data.email);
    if (data.mobile) formData.append("mobile", data.mobile);
    if (data.description) formData.append("description", data.description);

    return super.create(formData);
  }
}
